import axios from 'axios';

function getHeaders() {
    const session = localStorage.getItem('FOM_user');

    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session ? JSON.parse(session).userdata.token : null}`,
    };
}

/**
 *  @typedef {Object} GetModelEmbedUrlParamsLookerPaths
 *  @property {string} chart
 *  @property {string} table
 */

/**
 *  @typedef {Object} GetModelEmbedUrlParamsFilters
 *  @property {string?} attrib_id
 *  @property {string?} model_table_suffix
 */

/**
 *
 *  @typedef {Object} GetModelEmbedUrlParams
 *  @property {GetModelEmbedUrlParamsLookerPaths} lookerPaths
 *  @property {string} lookerModel
 *  @property {string|number} customerId
 *  @property {string|number} modelVersionId
 *  @property {GetModelEmbedUrlParamsFilters} filters
 */

/**
 * @param {GetModelEmbedUrlParams} params
 * @returns {Promise<AxiosResponse<any>>}
 */
function getModelEmbedUrl(params) {
    return axios
        .post(process.env.REACT_APP_API_URL + 'model/lookerEmbedUrl', params, {
            headers: getHeaders(),
        })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return err;
        });
}

function getAllOutputAttributes() {
    return axios
        .get(process.env.REACT_APP_API_URL + 'model/allOutputAttributes')
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return err;
        });
}

export { getModelEmbedUrl, getAllOutputAttributes };
